import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProviderParserFilePage = lazy(() => import('../views/update/ProviderParserFilePage'));

export function ProviderParserFilePageLazy() {
	return (
		<PageSuspense>
			<ProviderParserFilePage />
		</PageSuspense>
	);
}
